import { FC, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { demeterUserDataApi } from '../../../Apis/Apis';
import {
    DemeterCommodity,
    DemeterDataFrequency,
    DemeterDataSource,
    DemeterRegion,
    DemeterTableDefinitionType,
    DemeterUserType,
} from '../../../Generated/Raven-Demeter';
import { useApplicationSelector } from '../../../Redux/ReduxStore';
import { selectUserType } from '../../../Redux/Slices/UserSlice';
import useApi from '../../Apis/Hooks/useApiHook';
import { IRegionCommoditySelection } from '../../Components/Navigation/Hooks/useRegionCommodityNavigationHook';
import PhysicalPricesChart from '../PhysicalPrices/PhysicalPricesChart';

const UserDataChartPage: FC = () => {
    const { demeterUserDataGuid } = useParams();
    const currentUserType = useApplicationSelector(selectUserType);
    const isAdministrator = useMemo(() => currentUserType === DemeterUserType.Administrator, [currentUserType]);

    const [loading, , userDataResponse] = useApi(() => demeterUserDataApi.getDemeterUserData(demeterUserDataGuid!));

    if (loading || !userDataResponse || !isAdministrator) {
        return null;
    }

    const regionCommoditySelection = {
        dataFrequency: DemeterDataFrequency.Monthly,
        displayName: userDataResponse?.demeterUserData?.name,
        priceFrequency: DemeterDataFrequency.Monthly,
        dataSource: DemeterDataSource.All,
        extraParameters: userDataResponse?.demeterUserData?.demeterUserDataGuid,
        currency: userDataResponse?.demeterUserData?.currency,
        unitOfMeasure: userDataResponse?.demeterUserData?.unitOfMeasure,
        region: DemeterRegion.UserData,
        commodity: DemeterCommodity.UserData,
    } as unknown as IRegionCommoditySelection;

    return (
        <PhysicalPricesChart
            title={userDataResponse?.demeterUserData?.name ?? ''}
            dataFrequency={DemeterDataFrequency.Monthly}
            isXlsxDownloadAvailable
            regionCommoditySelections={[regionCommoditySelection]}
            tableDefinitionType={DemeterTableDefinitionType.CommodityPricesTable}
            displayDecimalPlacesMinimum={0}
            displayDecimalPlacesMaximum={4}
            currency={userDataResponse?.demeterUserData?.currency}
            unitOfMeasure={userDataResponse?.demeterUserData?.unitOfMeasure}
            testId="UserDataChart"
            track={{ eventCategory: 'UserData', eventAction: 'PhysicalPricesChart' }}
        />
    );
};

export default UserDataChartPage;
